import type { useStatsigDynamicHolidayConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-holiday-config.hook'

/**
 * Holiday-message helpers mirrored verbatim from the module-private helpers in legacy productCTA.tsx
 * (`hasValidDisplayTags` / `checkHolidayMessageShown`). They are not exported from the legacy module,
 * so they are reproduced here exactly — same conditions, same return shape — to keep the
 * holiday-message gating and the EDD `holidayMessageShown` signal in parity with legacy. Shared by
 * `ProductCTADSWrapper` and `useProductButtonBagDSVariant` so both derive the same signal.
 */
export const hasValidDisplayTags = (
  displayTags: string[] | undefined,
  holidayConfig: ReturnType<typeof useStatsigDynamicHolidayConfig> | null,
): boolean => {
  return !!(displayTags && Array.isArray(displayTags) && displayTags.length > 0 && holidayConfig?.tags)
}

export const checkHolidayMessageShown = (
  displayTags: string[],
  holidayConfig: ReturnType<typeof useStatsigDynamicHolidayConfig> | null,
  locale: string,
): boolean => {
  return displayTags.some(displayTag => {
    const tagConfig = holidayConfig?.tags.find(tag => tag.tag === displayTag && tag.enabled)
    if (tagConfig?.message) {
      const message = tagConfig.message[locale] ?? Object.values(tagConfig.message)[0] ?? null
      return !!message
    }
    return false
  })
}
